const LIVE_PROFILE_CHANNEL = 'linkit-live-profile-preview';
const LIVE_PROFILE_STORAGE_KEY = 'linkit_live_profile_preview';
const LIVE_PROFILE_TTL_MS = 2 * 60 * 1000;

function canUseWindow() {
  return typeof window !== 'undefined';
}

function makePayload(row) {
  return {
    type: 'profile:update',
    row,
    sentAt: Date.now(),
  };
}

export function publishLiveProfileUpdate(row) {
  if (!canUseWindow() || !row?.id) return;

  const payload = makePayload(row);

  try {
    const channel = new BroadcastChannel(LIVE_PROFILE_CHANNEL);
    channel.postMessage(payload);
    channel.close();
  } catch {
    // BroadcastChannel is an enhancement; localStorage below is the fallback.
  }

  try {
    window.localStorage.setItem(LIVE_PROFILE_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // Storage can be blocked in private modes.
  }
}

export function readLatestLiveProfileUpdate(username) {
  if (!canUseWindow()) return null;

  const normalizedUsername = String(username || '').trim().toLowerCase().replace(/^@/, '');
  if (!normalizedUsername) return null;

  try {
    const payload = JSON.parse(window.localStorage.getItem(LIVE_PROFILE_STORAGE_KEY) || 'null');
    const payloadUsername = String(payload?.row?.username || '').trim().toLowerCase().replace(/^@/, '');
    const isFresh = Number.isFinite(payload?.sentAt) && Date.now() - payload.sentAt < LIVE_PROFILE_TTL_MS;
    if (payload?.type === 'profile:update' && isFresh && payloadUsername === normalizedUsername) {
      return payload.row;
    }
  } catch {
    // Ignore malformed or inaccessible local preview data.
  }

  return null;
}

export function subscribeToLiveProfileUpdates(onUpdate) {
  if (!canUseWindow()) return () => {};

  let channel = null;

  const handlePayload = (payload) => {
    if (payload?.type === 'profile:update' && payload.row?.id) {
      onUpdate(payload.row);
    }
  };

  try {
    channel = new BroadcastChannel(LIVE_PROFILE_CHANNEL);
    channel.onmessage = (event) => handlePayload(event.data);
  } catch {
    // The storage event listener below still covers older browsers.
  }

  const handleStorage = (event) => {
    if (event.key !== LIVE_PROFILE_STORAGE_KEY || !event.newValue) return;
    try {
      handlePayload(JSON.parse(event.newValue));
    } catch {
      // Ignore malformed cross-tab preview payloads.
    }
  };

  window.addEventListener('storage', handleStorage);

  return () => {
    window.removeEventListener('storage', handleStorage);
    if (channel) channel.close();
  };
}
